import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

export type UpdateSquareRequest = {
  id: string;
  tenant_id?: string;
  contest_name_en?: string;
  contest_name_fr?: string;
  contest_subtext_en?: string;
  contest_subtext_fr?: string;
  lobby_tags?: string[] | null;
  status?: string;
  entry_fee?: number;
  max_squares_per_user?: number;
  start_time_utc?: string;
  selection_editable_until_utc?: string;
  row_team_id?: string;
  col_team_id?: string;
  row_team_display_name?: string;
  col_team_display_name?: string;
  row_team_bg_color?: string;
  col_team_bg_color?: string;
  row_team_icon_url?: string;
  col_team_icon_url?: string;
  sport?: string;
  fixture_id?: string;
  scheduled_game_start_utc?: string;
  feed_provider?: string;
  grid_rows?: number;
  grid_cols?: number;
  periods?: any[];
  winner_rule?: string;
  winner_rule_config?: any;
  payout_distribution_method?: string;
  total_prize_amount?: number;
  gam_enabled?: boolean;
  google_manager_sdk_enabled?: boolean;
  ad_units?: any[];
  sticky_footer_placement?: any;
  badge_image_url?: string;
  background_image_url?: string;
  rules_image_url?: string;
  submit_view_image_url?: string;
  [key: string]: any;
};

type UpdateSquareResponse = {
  squares_contest: {
    squares_contest_id: string;
    [key: string]: any;
  };
  message: string;
};

export const updateSquare = (
  id: string,
  data: Omit<UpdateSquareRequest, 'id'>
): Promise<UpdateSquareResponse> =>
  apiClient.put(`/api/admin/squares/${id}` as any, data) as Promise<UpdateSquareResponse>;

export const useUpdateSquareMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<UpdateSquareResponse, Error, UpdateSquareRequest>({
    mutationFn: async data => {
      const { id, ...updateData } = data;
      return updateSquare(id, updateData);
    },
    onSuccess: (_response, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.squares?.all || ['squares'] });
      queryClient.invalidateQueries({
        queryKey: queryKeys.squares?.detail(variables.id) || ['squares', variables.id],
      });
      toast.success('Squares contest updated successfully');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to update squares contest');
    },
  });
};
